<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CreditCardFormSkeleton',
});
</script>

<template>
  <div class="animate-pulse">
    <div class="w-full border-solid h-11 md:h-12 bg-neutral-200 border-neutral-200" />
    <div class="flex items-center mt-6 md:mt-8">
      <!-- eslint-disable-next-line max-len -->
      <div class="w-7/12 border-solid h-11 md:h-12 md:w-5/12 bg-neutral-200 border-neutral-200" />
      <!-- eslint-disable-next-line max-len -->
      <div
        class="w-4/12 ml-3 border-solid h-11 md:h-12 md:ml-5 bg-neutral-200 border-neutral-200"
      />
    </div>
  </div>
</template>
